const LEGACY_GROUP_META = {
  basic: {
    title: 'Language skills',
    description: 'Core programming fundamentals',
  },
  frameworks: {
    title: 'Framework skills',
    description: 'Tools for building modern applications',
  },
  ai: {
    title: 'AI skills',
    description: 'Cursor, agents, and LLMs for modern development',
  },
  devops: {
    title: 'DevOps Skills',
    description: 'Server administration, deployment, and production operations',
  },
}

function formatLegacyTitle(key) {
  return key
    .replace(/([A-Z])/g, ' $1')
    .replace(/[-_]/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase())
    .trim()
}

export function createSkillGroup(title = 'New category', description = '') {
  return {
    id: `group-${Date.now()}`,
    title,
    description,
    items: [],
  }
}

export function normalizeSkillGroups(skills) {
  if (Array.isArray(skills)) {
    return skills.map((group, index) => ({
      id: group?.id || `group-${index}`,
      title: group?.title || 'Skills',
      description: group?.description || '',
      items: Array.isArray(group?.items) ? group.items.map((item) => ({
        name: item?.name || '',
        level: Number(item?.level) || 0,
      })) : [],
    }))
  }

  if (!skills || typeof skills !== 'object') {
    return []
  }

  return Object.entries(skills).map(([key, items]) => ({
    id: key,
    title: LEGACY_GROUP_META[key]?.title || formatLegacyTitle(key),
    description: LEGACY_GROUP_META[key]?.description || '',
    items: Array.isArray(items)
      ? items.map((item) => ({
          name: item?.name || '',
          level: Number(item?.level) || 0,
        }))
      : [],
  }))
}
